export default "__VITE_ASSET__COl3Fc1T__"